import classNames from "classnames"
import { useEffect, useState } from "react"

export type Tab = {
  name: string
  count?: number
  selected?: boolean
  visible?: boolean
}

export type TabProps = {
  tabs: Tab[]
  onSelect: any
  className?: string
}

export default function GalleryTabs({ tabs, onSelect, className }: TabProps) {

  const [currentTab, setCurrentTab] = useState<Tab>()

  // Set the current tab
  useEffect(() => {
    const tab = tabs.find(t => t.selected)
    setCurrentTab(tab)
  }, [])

  function onTabClick(tab: Tab) {
    setCurrentTab(tab)
    onSelect(tab)
  }

  return (
    <div className={classNames(`flex flex-wrap`, className)}>
      {tabs.map((tab) => {
        return tab.visible ?
          <div
            key={`tab-${tab.name.replace(' ', '-')}`}
            onClick={() => {
              onTabClick(tab)
            }}
            className={classNames(
              `border-b-2 py-4 px-4 cursor-pointer transition-all`,
              tab.name == currentTab?.name ? `text-red-500 border-red-500` : `border-black hover:border-gray-700`
            )}>
            {tab.name}
            {tab.count > 0 &&
              <span className={classNames(
                `ml-3 px-3 py-1 rounded-xl text-xs transition-all bg-red-500`,
                tab.name == currentTab?.name ? `text-red-300` : 'text-red-500 bg-opacity-20'
              )}>{tab.count}</span>}
          </div> : null
      })}
    </div>
  )
}
